import Carrier from "@Components/Carrier/Carrier";
import { useTranslation } from "react-i18next";
import FareRules from "../../FareRules/FareRules";
import FareRulesTrigger from "../components/FareRulesTrigger";

export default function FareRulesDrawerMob() {
  const { t } = useTranslation();

  return (
    <Carrier
      label={t("Flights.details.fareRules.fareRules")}
      renderTrigger={({ open }) => <FareRulesTrigger onOpen={open} />}
      renderSheet={() => (
        <div className="p-4">
          <FareRules />
        </div>
      )}
    />
  );
}
